function hexToRgb(hex) {
  hex = hex.trim();
  var result = hex.match(/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
}

function bindColorSwatch(swatch) {
  // Get rgb value from hex
  const hex = swatch.querySelector(".color").innerText;
  const rgb = hexToRgb(hex);
  if (rgb === null) {
    console.error("Could not convert hex code to RGB:", hex);
    return;
  }
  const rgbString = `rgb(${rgb.r}, ${rgb.g}, ${rgb.b})`;
  swatch.querySelector(".color-generated button").innerText = rgbString;
  // Bind copyable values
  const copyable = swatch.querySelectorAll(".copyable button");
  copyable.forEach((field) => {
    const value = field.innerText;
    field.addEventListener("mouseover", (e) => {
      field.innerText = "Copy";
    });
    field.addEventListener("mouseout", (e) => {
      if (!field.classList.contains("copied")) {
        field.innerText = value;
      }
    });
    field.addEventListener("click", (e) => {
      navigator.clipboard.writeText(value).then(() => {
        field.classList.add("copied");
        field.innerText = "Copied!";
        setTimeout(() => {
          field.classList.remove("copied");
          field.innerText = value;
        }, 1000);
      });
    });
  });
}

export default function bindColorSwatches() {
  const colorSwatches = document.querySelectorAll(".color-swatch");
  colorSwatches.forEach((swatch) => {
    bindColorSwatch(swatch);
  });
}
